import { Icon } from "@/enums";

export default {
  state: {
    /** 票务信息 */
    ticketId: "", // ID
    ticketTitle: "", // 名称
    ticketUrl: "", // URL
    ticketPic: `/img/ticketPic/tubiao.jpg`, // 图片

    /** 列表信息 */
    currentPlayList: [], // 当前列表
    ticketDetails: null, // 单个信息
    Details: null,
    currentPlayIndex: -1, // 当前位置
  },
  getters: {
    ticketId: (state) => state.ticketId,
    ticketTitle: (state) => state.ticketTitle,
    ticketUrl: (state) => state.ticketUrl,
    ticketPic: (state) => state.ticketPic,

    currentPlayList: (state) => state.currentPlayList,
    ticketDetails: (state) => state.ticketDetails,
    Details: (state) => state.Details,
    currentPlayIndex: (state) => state.currentPlayIndex,
  },
  mutations: {
    setTicketId: (state, ticketId) => {
      state.ticketId = ticketId;
    },
    setTicketTitle: (state, ticketTitle) => {
      state.ticketTitle = ticketTitle;
    },
    setTicketUrl: (state, ticketUrl) => {
      state.ticketUrl = ticketUrl;
    },
    setTicketPic: (state, ticketPic) => {
      state.ticketPic = ticketPic;
    },
    
    setCurrentPlayList: (state, currentPlayList) => {
      state.currentPlayList = currentPlayList;
    },
    setDetails: (state, Details) => {
      state.Details = Details;
    },
    setTicketDetails: (state, ticketDetails) => {
      state.ticketDetails = ticketDetails;
    },
    setCurrentPlayIndex: (state, currentPlayIndex) => {
      state.currentPlayIndex = currentPlayIndex;
    },
  },
};
